export default "__VITE_ASSET__DKgSmuVD__"